import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { FileUploaderComponent } from '../../../../shared/Components/file-uploader/file-uploader.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { InstitutionService } from '../../Service/InstitationService';
import { AddInstitutionComponent } from '../add-institution/add-institution.component';
import { InstitutionDetailsComponent } from '../institution-details/institution-details.component';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';


@Component({
  selector: 'get-institution',
  templateUrl: './get-institution.component.html',
  styleUrls: ['./get-institution.component.scss']
})

export class GetInstitutionsComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: InstitutionService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    public sanitizer: DomSanitizer,
    private paging: PagingService
  ) {
    super(route, service, paging, '', diag);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  intitForm() {
    this.form = this.fb.group({
      name: [''],
    });
  }

  handleSearch() {
    if (!this.form.value.name && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاء اختيار العنوان  لاتمام عملية البحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.name) {
      serchTermArr.push(`name:${this.form.value.name.trim()}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['name'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  add() {
    this.dialog
      .open(AddInstitutionComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') {
          this.toast.show('تم الاضافة بنجاح', '', { status: 'success', duration: 3000 });
          this.loadEntities();
        }
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(InstitutionDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddInstitutionComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
